import { Stack } from "expo-router";
import { useTheme } from "@/hooks/useTheme";
import Head from "expo-router/head";

export default function ClockinLayout() {
  const { colors } = useTheme();

  return (
    <>
      <Head>
        <title>RockForce Clock-in</title>
        <meta name="description" content="Clock in to your shift" />
      </Head>
      <Stack
        screenOptions={{
          animation: "simple_push",
          headerShown: false,
          contentStyle: { backgroundColor: colors.background },
        }}
      >
        <Stack.Screen name="[shift]" />
      </Stack>
    </>
  );
}
